module.exports = __webpack_public_path__ + "static/media/make-your-move.87b4ddc0.png";